<template>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="">
          <div class="">
            <div class="vx-row mb-6">
              <div class="vx-col w-full my-2">
                <vs-input
                  v-model="model.name"
                  name="unitName"
                  :label="$t('Unit')"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('unitName')"
                  >{{ errors.first("unitName") }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <vs-button
            type="filled"
            class="float-right mb-4 mt-4"
            @click.prevent="submitForm"
            :disabled="(!model.name)"
            >{{ $t("Save") }}</vs-button
          >
      </form>
    </vs-popup>
  </template>
  <script>
  import { mapActions } from "vuex";
  import { Validator } from "vee-validate";
  
  const dict = {
    custom: {
        unitName: {
        required: "لطفا عنوان دپارتمان را وارد نمایید.",
      },
  
    },
  };
  Validator.localize("fa", dict);
  
  export default {
      props: {
      show: { default: false },
      model: {
        default: {},
      },
    },
    data() {
      return {
        popupTitle: "",
        disabled: false,
      };
    },
    computed: {
      showModal: {
        get: function () {
          return this.show;
        },
        set: function () {
          this.$emit("close");
        },
      },
    },
    methods: {
      ...mapActions({
        createAccount: "unit/createUnit",
        updateAccount: "unit/editUnit",
      }),
      submitForm() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (this.model.id != null) {
              this.updateAccount(this.model).then(() => {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.$emit("finish");
                this.model = {};
                this.$validator.reset();
                this.disabled = false;
              });
            } else {
              this.createAccount(this.model).then(() => {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.$emit("finish");
                this.model = {};
                this.$validator.reset();
                this.disabled = false;
              });
            }
          } else {
            // form have errors
          }
        });
      },
    },
    watch: {
      show() {
        if (this.show == true) {
          this.disabled = false;
  
          if (this.model.id) this.popupTitle = "EditUnit";
          else this.popupTitle = "CreateUnit";
        }
        this.$validator.reset();
      },
    },
  };
  </script>
  